import {
  ChangeDetectionStrategy,
  Component,
  ElementRef,
  Input,
  ViewChild,
  inject,
} from '@angular/core';
import { Router } from '@angular/router';
import { TranslocoDirective } from '@jsverse/transloco';
import { coreRoutesNames } from 'src/core/routes/core.routes.names';

@Component({
  selector: 'core-sidebar',
  templateUrl: './sidebar.component.html',
  standalone: true,
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [TranslocoDirective],
})
export class SidebarComponent {
  private router = inject(Router);

  @Input() hasToggleButton: boolean | undefined;
  @ViewChild('sidebarDrawer') private sidebar: ElementRef | undefined;

  dashboardButtonClick() {
    this.router.navigate([coreRoutesNames.DASHBOARD]);
  }

  newsBlogButtonClick() {
    this.router.navigate([coreRoutesNames.NEWS]);
  }

  userManagementButtonClick() {
    this.router.navigate([coreRoutesNames.USERS]);
  }

  toggleSidebar() {
    const isChecked = this.sidebar?.nativeElement.checked;
    if (this.sidebar) this.sidebar.nativeElement.checked = !isChecked;
  }
}
